var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.55"},React.createElement("path",{"d":"M19.9829 64.4589C19.0835 64.4572 18.2001 64.2214 17.4194 63.7748C15.6616 62.7787 14.5688 60.8451 14.5688 58.746V16.2655C14.5688 14.1605 15.6616 12.2328 17.4194 11.2367C18.2187 10.7774 19.1266 10.5412 20.0483 10.5528C20.9701 10.5644 21.8718 10.8233 22.6592 11.3026L58.9653 33.035C59.722 33.5095 60.3457 34.1683 60.7781 34.9498C61.2105 35.7313 61.4373 36.6097 61.4373 37.5028C61.4373 38.3959 61.2105 39.2744 60.7781 40.0558C60.3457 40.8373 59.722 41.4961 58.9653 41.9706L22.6533 63.7089C21.8475 64.196 20.9245 64.4552 19.9829 64.4589Z","fill":"white"})));
}

Play.defaultProps = {"width":"76","height":"75","viewBox":"0 0 76 75","fill":"none"};

module.exports = Play;

Play.default = Play;
